/* REACT IMPORTS */
import { useEffect } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

/* STYLES */
import "../styles/global.css";

/* LAYOUT */
import Layout from "../layout";

/* PAGES */
import AuthLogin from "../pages/auth/login";
import AuthRegister from "../pages/auth/register";
import Teacher from "../pages/teacher";
import Institute from "../pages/institute";
import Student from "../pages/student";
import WorkforceAdmin from "pages/workforce-admin";
import RSVPList from "pages/rsvp";
import Feedback from "pages/feedback";

/* SCROLL TO TOP */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<AuthLogin />} />
          <Route path="/register" element={<AuthRegister />} />
          <Route
            path="/teacher"
            element={
              <Layout>
                <Teacher />
              </Layout>
            }
          />
          <Route
            path="/institute"
            element={
              <Layout>
                <Institute />
              </Layout>
            }
          />
          <Route
            path="/student"
            element={
              <Layout>
                <Student />
              </Layout>
            }
          />
          <Route
            path="/workforce-admin"
            element={
              <Layout>
                <WorkforceAdmin />
              </Layout>
            }
          />
          <Route
            path="/rsvp"
            element={
              <Layout>
                <RSVPList />
              </Layout>
            }
          />
          <Route
            path="/feedback"
            element={
              <Layout>
                <Feedback />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
